// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notice[data-v-938435c4] {\n  background: #fffbe5;\n}", ""]);
// Exports
module.exports = exports;
